/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type HpRespPromoModuleSecondary_componentModule = {
    readonly messages: {
        readonly title: string | null;
        readonly items: ReadonlyArray<{
            readonly cmsId: number | null;
            readonly linkData: {
                readonly path: string | null;
            };
            readonly " $fragmentRefs": FragmentRefs<"HpRespPromoModulePromoItem_promotion">;
        } | null> | null;
    } | null;
    readonly " $refType": "HpRespPromoModuleSecondary_componentModule";
};
export type HpRespPromoModuleSecondary_componentModule$data = HpRespPromoModuleSecondary_componentModule;
export type HpRespPromoModuleSecondary_componentModule$key = {
    readonly " $data"?: HpRespPromoModuleSecondary_componentModule$data;
    readonly " $fragmentRefs": FragmentRefs<"HpRespPromoModuleSecondary_componentModule">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "userType"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "HpRespPromoModuleSecondary_componentModule",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "userType",
          "variableName": "userType"
        }
      ],
      "concreteType": "PromoModuleMessages",
      "kind": "LinkedField",
      "name": "messages",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PromoItem",
          "kind": "LinkedField",
          "name": "items",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cmsId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "LinkData",
              "kind": "LinkedField",
              "name": "linkData",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "path",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "HpRespPromoModulePromoItem_promotion"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "PromoModule",
  "abstractKey": null
};
(node as any).hash = 'b0f6a34cb76b0e707a3737437cf919bb';
export default node;
